import unimetd from "../../../../assets/images/productos/unimetD/Unimet D (1).png";
import qr from "../../../../assets/images/QR Daniel Montes.svg";
import Producto from "../../../../components/producto";
import pic1 from "../../../../assets/images/productos/unimetD/Mosaico - UD1.png";
import pic2 from "../../../../assets/images/productos/unimetD/Mosaico - UD2.jpg";
import { useTranslation } from "react-i18next";

function UnimetD() {

  const {t} = useTranslation();

  return (
    <Producto
      fotos={[pic1, pic2]}
      datosTabla1={[
        [t("tensionNominal"), "kV", "24"],
        [t("corrienteNominal"), "A", "1.250 / 2.000 / 2.500 / 3.150"],
        [t("corrienteBreveDuracion"), "kA", "25 / 31,5 / 40"],
        [t("corrienteDinamica"), "kA", "63 / 78 / 100"],
        [t("nivelDeAislacion"), "kV", "50"],
        [t("tensionDeImpulso"), "kV", "125"],
        [t("frecuenciaNominal"), "Hz", "50 / 60"],
      ]}
      datosTabla2={[
        [t("ancho"), "mm", "650 / 1.000"],
        [t("alto"), "mm", "2.500"],
        [t("profundo"), "mm", "1.600 / 2.000"],
      ]}
      nombreProducto={"Unimet D"}
      fotoProducto={unimetd}
      descripcionProducto={t("unimetD.titulo_descripcion") }
      caracteristicas={[
        t("unimetD.bullet1"),
        t("unimetD.bullet2"),
        t("unimetD.bullet3"),
        t("unimetD.bullet4"),
        t("unimetD.bullet5"),
        t("unimetD.bullet6"),
        t("unimetD.bullet7"),
        t("unimetD.bullet8"),
        t("unimetD.bullet9")
      ]}
      vendedor={{
        nombre: "Daniel Montes",
        telefono: "+54 9 11 3167-6868",
        mail: "dmontes@ema.com.ar",
        qr: qr,
      }}
      pathPdf={'/assets/docs/2025%20-%20Unimet%20D.pdf'}
    />
  );
}

export default UnimetD;
